import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import {
	useCreateOrganizationTypePosition,
	useUpdateOrganizationTypePosition,
} from "../hooks/useOrganizationTypePositions";
import { usePositionsStore } from "../store/positions.store";
import type { CreateOrganizationTypePositionRequest } from "../types";
import { PositionForm } from "./PositionForm";

export function PositionFormModal() {
	const [form] = Form.useForm<CreateOrganizationTypePositionRequest>();
	const { modalOpen, editingItem, closeModal } = usePositionsStore();

	const { mutate: create, isPending: isCreating } = useCreateOrganizationTypePosition();
	const { mutate: update, isPending: isUpdating } = useUpdateOrganizationTypePosition();

	const close = () => {
		form.resetFields();
		closeModal();
	};

	useEffect(() => {
		if (modalOpen) {
			if (editingItem) {
				form.setFieldsValue({ name: editingItem.name });
			} else {
				form.resetFields();
			}
		}
	}, [modalOpen, editingItem, form]);

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				if (editingItem) {
					update({ id: editingItem.id, data: { name: values.name } }, { onSuccess: close });
				} else {
					create(values, { onSuccess: close });
				}
			})
			.catch(() => {
				// Validation failed - Form shows errors inline
			});
	};

	return (
		<FormModal
			open={modalOpen}
			editing={!!editingItem}
			title="Yangi lavozim"
			editTitle="Lavozimni tahrirlash"
			onCancel={close}
			onOk={handleSubmit}
			confirmLoading={isCreating || isUpdating}
		>
			<PositionForm form={form} />
		</FormModal>
	);
}
